import AbstractRepository from '@services/repositories/AbstractRepository';

export default class CodeTypesRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/product_code_types');
    }

    getByType(type) {
        return this.where('type', type);
    }
}
